var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrDown2 = function SvgArrDown2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m499.4 556.3-.1-.1-.2.1-371.6-371.6L0 312.2l499.1 499.1.2-.1.1.1 499.1-499.1-127.4-127.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrDown2);
export default ForwardRef;